// API Value Mappings for Roomvia AI API
// Maps UI selections to exact API parameter values

export interface APIParameters {
  roomType: string
  roomTheme: string
  roomDimension: string
  roomPrimaryColor: string
  roomAccentColors: string
}

// Room Type Mappings - UI values to API values
export const ROOM_TYPE_MAPPINGS = [
  { order: 13, name: "Breakfast Nook", value: "breakfast-nook", image: "images/roomTypes/breakfast-nook.png", icon: "Coffee" },
  { order: 18, name: "Den", value: "den", image: "images/roomTypes/den.png", icon: "Armchair" },
  { order: 6, name: "Dining Room", value: "dining-room", image: "images/roomTypes/dining-room.png", icon: "Utensils" },
  { order: 12, name: "Entryway", value: "entryway", image: "images/roomTypes/entryway.png", icon: "DoorOpen" },
  { order: 5, name: "Family Room", value: "family-room", image: "images/roomTypes/family-room.png", icon: "Users" },
  { order: 14, name: "Formal Dining Room", value: "formal-dining-room", image: "images/roomTypes/formal-dining-room.png", icon: "Wine" },
  { order: 7, name: "Secondary Bedroom", value: "guest-bedroom", image: "images/roomTypes/secondary-bedroom.png", icon: "BedSingle" },
  { order: 8, name: "Secondary Bathroom", value: "guest-bathroom", image: "images/roomTypes/secondary-bathroom.png", icon: "Shower" },
  { order: 11, name: "Home Office", value: "home-office", image: "images/roomTypes/home-office.png", icon: "Briefcase" },
  { order: 9, name: "Kids Bathroom", value: "kids-bathroom", image: "images/roomTypes/kids-bathroom.png", icon: "Baby" },
  { order: 10, name: "Kids Bedroom", value: "kids-bedroom", image: "images/roomTypes/kids-bedroom.png", icon: "Gamepad2" },
  { order: 15, name: "Eat-in Kitchen", value: "eat-in-kitchen", image: "images/roomTypes/eat-in-kitchen.png", icon: "UtensilsCrossed" },
  { order: 2, name: "Kitchen", value: "kitchen", image: "images/roomTypes/kitchen.png", icon: "ChefHat" },
  { order: 16, name: "Laundry Room", value: "laundry-room", image: "images/roomTypes/laundry-room.png", icon: "Shirt" },
  { order: 3, name: "Living Room", value: "living-room", image: "images/roomTypes/living-room.png", icon: "Sofa" },
  { order: 4, name: "Primary Bathroom", value: "primary-bathroom", image: "images/roomTypes/primary-bathroom.png", icon: "Bath" },
  { order: 1, name: "Primary Bedroom", value: "primary-bedroom", image: "images/roomTypes/primary-bedroom.png", icon: "BedDouble" },
  { order: 17, name: "Nursery", value: "nursery", image: "images/roomTypes/nursery.png", icon: "Heart" },
  { order: 19, name: "Walk In Closet", value: "walk-in-closet", image: "images/roomTypes/walk-in-closet.png", icon: "Shirt" },
  { order: 20, name: "Dorm Room", value: "dorm-room", image: "images/roomTypes/dorm-room.png", icon: "GraduationCap" },
  { order: 21, name: "Man Cave", value: "man-cave", image: "images/roomTypes/man-cave.png", icon: "Football" },
  { order: 22, name: "Teen Lounge", value: "teen-lounge", image: "images/roomTypes/teen-lounge.png", icon: "Headphones" },
  { order: 23, name: "Kids Playroom", value: "kids-playroom", image: "images/roomTypes/kids-playroom.png", icon: "Puzzle" },
  { order: 24, name: "Ladies Lounge", value: "ladies-lounge", image: "images/roomTypes/ladies-lounge.png", icon: "Flower2" },
  { order: 25, name: "Powder Room", value: "powder-room", image: "images/roomTypes/powder-room.png", icon: "HandHeart" },
  { order: 26, name: "Pantry", value: "pantry", image: "images/roomTypes/pantry.png", icon: "Cookie" },
  { order: 27, name: "Sunroom", value: "sunroom", image: "images/roomTypes/sunroom.png", icon: "Sunrise" },
  { order: 28, name: "Screened-In Porch", value: "screened-in-porch", image: "images/roomTypes/screened-in-porch.png", icon: "TreePine" },
]

// Room Theme Mappings - UI values to API values
export const ROOM_THEME_MAPPINGS = [
  { name: "Art Deco", value: "art-deco-theme", image: "images/roomThemes/art-deco-theme.png" },
  { name: "Beach House", value: "beach-house-theme", image: "images/roomThemes/beach-house-theme.png" },
  { name: "Bohemian", value: "bohemian-theme", image: "images/roomThemes/bohemian-theme.png" },
  { name: "Coastal", value: "coastal-theme", image: "images/roomThemes/coastal-theme.png" },
  { name: "Contemporary", value: "contemporary-theme", image: "images/roomThemes/contemporary-theme.png" },
  { name: "Cottage Core", value: "cottage-core-theme", image: "images/roomThemes/cottage-core-theme.png" },
  { name: "Eclectic", value: "eclectic-theme", image: "images/roomThemes/eclectic-theme.png" },
  { name: "Farmhouse", value: "farmhouse-theme", image: "images/roomThemes/farmhouse-theme.png" },
  { name: "French Country", value: "french-country-theme", image: "images/roomThemes/french-country-theme.png" },
  { name: "Glam", value: "glam-theme", image: "images/roomThemes/glam-theme.png" },
  { name: "Hamptons", value: "hamptons-theme", image: "images/roomThemes/hamptons-theme.png" },
  { name: "Hollywood Regency", value: "hollywood-regency-theme", image: "images/roomThemes/hollywood-regency-theme.png" },
  { name: "Industrial", value: "industrial-theme", image: "images/roomThemes/industrial-theme.png" },
  { name: "Japandi", value: "japandi-theme", image: "images/roomThemes/japandi-theme.png" },
  { name: "Luxury", value: "luxury-theme", image: "images/roomThemes/luxury-theme.png" },
  { name: "Mediterranean", value: "mediterranean-theme", image: "images/roomThemes/mediterranean-theme.png" },
  { name: "Mid Century", value: "mid-century-theme", image: "images/roomThemes/mid-century-theme.png" },
  { name: "Minimalist", value: "minimalist-theme", image: "images/roomThemes/minimalist-theme.png" },
  { name: "Modern Farmhouse", value: "modern-farmhouse-theme", image: "images/roomThemes/modern-farmhouse-theme.png" },
  { name: "Modern", value: "modern-theme", image: "images/roomThemes/modern-theme.png" },
  { name: "Mountain Chalet", value: "mountain-chalet-theme", image: "images/roomThemes/mountain-chalet-theme.png" },
  { name: "North Woods", value: "north-woods-theme", image: "images/roomThemes/north-woods-theme.png" },
  { name: "Rustic", value: "rustic-theme", image: "images/roomThemes/rustic-theme.png" },
  { name: "Scandinavian", value: "scandinavian-theme", image: "images/roomThemes/scandinavian-theme.png" },
  { name: "Shabby Chic", value: "shabby-chic-theme", image: "images/roomThemes/shabby-chic-theme.png" },
  { name: "Southwestern", value: "southwestern-theme", image: "images/roomThemes/southwestern-theme.png" },
  { name: "Traditional", value: "traditional-theme", image: "images/roomThemes/traditional-theme.png" },
  { name: "Transitional", value: "transitional-theme", image: "images/roomThemes/transitional-theme.png" },
  { name: "Tropical", value: "tropical-theme", image: "images/roomThemes/tropical-theme.png" },
  { name: "Urban Modern", value: "urban-modern-theme", image: "images/roomThemes/urban-modern-theme.png" },
  { name: "Victorian", value: "victorian-theme", image: "images/roomThemes/victorian-theme.png" },
  { name: "Vintage", value: "vintage-theme", image: "images/roomThemes/vintage-theme.png" },
]

// Room Dimension Mappings - UI values to API values
export const ROOM_DIMENSION_MAPPINGS = [
  { name: "Extra Small", value: "minimum size of 36 square feet where minimum length or width of any side is 6 feet)" },
  { name: "Small", value: "small (minimum size of 100 square feet where minimum length or width of any side is 8 feet)" },
  { name: "Medium", value: "medium (minimum size of 144 square feet where minimum length or width of any side is 10 feet)" },
  { name: "Large", value: "large (minimum size of 196 square feet where minimum length or width of any side is 12 feet)" },
  { name: "Extra Large", value: "extra-large (minimum size of 324 square feet where minimum length or width of any side is 14 feet)" },
]

// Get all valid API values for validation
const VALID_ROOM_TYPES = ROOM_TYPE_MAPPINGS.map((m) => m.value)
const VALID_ROOM_THEMES = ROOM_THEME_MAPPINGS.map((m) => m.value)
const VALID_ROOM_DIMENSIONS = ROOM_DIMENSION_MAPPINGS.map((m) => m.value)

// Helper function to check if value is already a valid API value
function isValidAPIValue(value: string, validValues: string[]): boolean {
  return validValues.includes(value)
}

// Helper function to find mapping value
function findMappingValue(mappings: { name: string; value: string }[], uiValue: string): string | null {
  // Try exact match first
  const exactMatch = mappings.find((m) => m.name === uiValue)
  if (exactMatch) return exactMatch.value

  // Try case-insensitive match
  const caseInsensitiveMatch = mappings.find((m) => m.name.toLowerCase() === uiValue.toLowerCase())
  if (caseInsensitiveMatch) return caseInsensitiveMatch.value

  return null
}

// Validate hex color format
function isValidHexColor(color: string): boolean {
  return /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/.test(color)
}

// Format accent colors (comma-separated, max 10)
function formatAccentColors(colors: string[]): string {
  const validColors = colors
    .filter((color) => color && color.trim())
    .slice(0, 10) // Max 10 colors
    .map((color) => color.trim())

  return validColors.join(", ")
}

// Main mapping function - converts UI selections to API parameters
export function mapUISelectionsToAPIParams(uiSelections: {
  roomType?: string
  roomTheme?: string
  roomDimension?: string
  roomPrimaryColor?: string
  roomAccentColors?: string[]
}): APIParameters {
  console.log("🔄 Mapping UI selections to API parameters:", uiSelections)

  // Map room type
  let roomType = "living-room" // Default fallback
  if (uiSelections.roomType) {
    // Check if it's already a valid API value
    if (isValidAPIValue(uiSelections.roomType, VALID_ROOM_TYPES)) {
      roomType = uiSelections.roomType
      console.log(`✅ Room type already valid API value: ${roomType}`)
    } else {
      // Try to map from UI value
      const mappedType = findMappingValue(ROOM_TYPE_MAPPINGS, uiSelections.roomType)
      if (mappedType) {
        roomType = mappedType
        console.log(`✅ Mapped room type: ${uiSelections.roomType} → ${roomType}`)
      } else {
        console.warn(`⚠️ No mapping found for room type: ${uiSelections.roomType}, using default: ${roomType}`)
      }
    }
  }

  // Map room theme
  let roomTheme = "modern-theme" // Default fallback
  if (uiSelections.roomTheme) {
    // Check if it's already a valid API value
    if (isValidAPIValue(uiSelections.roomTheme, VALID_ROOM_THEMES)) {
      roomTheme = uiSelections.roomTheme
      console.log(`✅ Room theme already valid API value: ${roomTheme}`)
    } else {
      // Try to map from UI value
      const mappedTheme = findMappingValue(ROOM_THEME_MAPPINGS, uiSelections.roomTheme)
      if (mappedTheme) {
        roomTheme = mappedTheme
        console.log(`✅ Mapped room theme: ${uiSelections.roomTheme} → ${roomTheme}`)
      } else {
        console.warn(`⚠️ No mapping found for room theme: ${uiSelections.roomTheme}, using default: ${roomTheme}`)
      }
    }
  }

  // Map room dimension
  let roomDimension = "medium" // Default fallback
  if (uiSelections.roomDimension) {
    // Check if it's already a valid API value
    if (isValidAPIValue(uiSelections.roomDimension, VALID_ROOM_DIMENSIONS)) {
      roomDimension = uiSelections.roomDimension
      console.log(`✅ Room dimension already valid API value: ${roomDimension}`)
    } else {
      // Try to map from UI value
      const mappedDimension = findMappingValue(ROOM_DIMENSION_MAPPINGS, uiSelections.roomDimension)
      if (mappedDimension) {
        roomDimension = mappedDimension
        console.log(`✅ Mapped room dimension: ${uiSelections.roomDimension} → ${roomDimension}`)
      } else {
        console.warn(
          `⚠️ No mapping found for room dimension: ${uiSelections.roomDimension}, using default: ${roomDimension}`,
        )
      }
    }
  }

  // Handle primary color
  let roomPrimaryColor = "Blue" // Default fallback
  if (uiSelections.roomPrimaryColor) {
    roomPrimaryColor = uiSelections.roomPrimaryColor
    if (isValidHexColor(roomPrimaryColor)) {
      console.log(`✅ Using hex primary color: ${roomPrimaryColor}`)
    } else {
      console.log(`✅ Using named primary color: ${roomPrimaryColor}`)
    }
  }

  // Handle accent colors
  let roomAccentColors = "White, Gray" // Default fallback
  if (uiSelections.roomAccentColors && uiSelections.roomAccentColors.length > 0) {
    roomAccentColors = formatAccentColors(uiSelections.roomAccentColors)
    console.log(`✅ Formatted accent colors: ${roomAccentColors}`)
  }

  const apiParams: APIParameters = {
    roomType,
    roomTheme,
    roomDimension,
    roomPrimaryColor,
    roomAccentColors,
  }

  console.log("🎯 Final API parameters:", apiParams)
  return apiParams
}

// Export individual mapping arrays for use in UI components
export { ROOM_TYPE_MAPPINGS as roomTypes }
export { ROOM_THEME_MAPPINGS as roomThemes }
export { ROOM_DIMENSION_MAPPINGS as roomDimensions }
